export const SET_ACCORDION = 'SET_ACCORDION'
export const SET_OWNER = 'SET_OWNER'
export const SET_OWNER_ERROR = 'SET_OWNER_ERROR'
export const SET_OWNER_SELECTED = 'SET_OWNER_SELECTED'
export const SET_TAB = 'SET_TAB'

